﻿<template>
  <div>

    <div class="divTable" role="table" v-if="items.length">
        <div class="divTable-head" role="rowgroup">
            <div class="divTable-head-row" role="row">
               
		<div @click="sortBy(tableId[0])" class="divTable-head-row-cell active: sortKey == tableId[0]" role="columnheader">Job Title
		<span class="arrow" :class="sortOrders[tableId[0]] > 0 ? 'asc' : 'dsc'">  </span> </div> 
		 <div @click="sortBy(tableId[1])" class="divTable-head-row-cell active: sortKey == tableId[1]" role="columnheader">Job Function
		 <span class="arrow" :class="sortOrders[tableId[1]] > 0 ? 'asc' : 'dsc'">  </span> </div> 
		 <div @click="sortBy(tableId[2])" class="divTable-head-row-cell active: sortKey == tableId[2]" role="columnheader">Location
		 <span class="arrow" :class="sortOrders[tableId[2]] > 0 ? 'asc' : 'dsc'">  </span> </div> 
		 <div @click="sortBy(tableId[3])" class="divTable-head-row-cell active: sortKey == tableId[3]" role="columnheader" style="padding: 10px 2px;"  >Date Posted
		 <span class="arrow" :class="sortOrders[tableId[3]] > 0 ? 'asc' : 'dsc'">  </span></div> 
            </div>
        </div>
        <div class="divTable-body" role="rowgroup">
            <!-- Product Row -->
            <div
                appear
                name="v-fade"
                v-for="(item, index) in items"
                class="divTable-body-row"
                role="row"
                :key="index"
            >
                <!-- Table-cell (job title)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_product" role="cell">
                    <div class="divTable-body-row-cell-content">
                        <span class="hide_MD m-fontColor_black"> {{item.name}}</span>
                        <a :href="item.url" :aria-label="item.name" class="link hide show_MD" target="_blank"> {{item.name}}</a>
                    </div>
                </div>

                <!-- Table-cell (job function)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_qty" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.jobFunction}}
                    </div>
                </div>

                <!-- Table-cell (location)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_price" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.location}}
                    </div>
                </div>

                <!-- Table-cell (date posted)-->
                <div class="divTable-body-row-cell divTable-body-row-cell_remove" role="cell">
                    <div class="divTable-body-row-cell-content">
                        {{item.datePosted}}
                    </div>
                </div>
                <a :href="item.url" target="_blank" aria-label="apply now" class="btn btn_tertiary visuallyHide_MD btn_fullWidthMobile">Apply Now</a>
            </div>
        </div>
    </div>
    <div v-else class="section_padding">
        <div class="vr_10 hdg_2 m-text_center" >We’re sorry but your search turned up 0 results. Let’s try again.</div>
        <div class="m-text_center"><button class="btn btn" @click="$emit('reset-search')">Reset</button></div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['items', 'tableId', 'sortByColumn', 'sortorder'],
    data: function () {
    var sortOrders = {}
	var prekey = '';
	var preval = '';
	for(var key in this.sortorder)
	{
	prekey = key;
	preval = this.sortorder[prekey];
	}
    this.tableId.forEach(function (key) {
	
	if(key == 'datePosted' && prekey == '')
	{
	  sortOrders[key] = -1
	}
	else
	{
	sortOrders[key] = 1
	}
	if(key == prekey)
	{
	sortOrders[key] = preval;
	}
    })
    return {
      sortKey: '',
      sortOrders: sortOrders
	  
    }
  },
  //computed: {
   // filteredHeroes: function () {
  //    var sortKey = this.sortKey
  //    var order = this.sortOrders[sortKey] || 1
  //   var heroes = this.items
   //   if (sortKey) {
  //      heroes = heroes.slice().sort(function (a, b) {
  //        a = a[sortKey]
  //        b = b[sortKey]
  //        return (a === b ? 0 : a > b ? 1 : -1) * order
  //      })
  //    }
   //   return heroes
   // }
  //},
  
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
	  this.sortByColumn(key, this.sortOrders[key])
    }
  }
};
</script>
